import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../components/helpers/StatePresenter'
import Loading from '../../../../../../packages/kiti/components/helpers/Loading'

const PlaceAssetsContext = React.createContext({})
const { Provider } = PlaceAssetsContext
export const usePlaceAssetsState = () => React.useContext(PlaceAssetsContext)
export const usePlaceAssets = () => usePlaceAssetsState()?.assets || []

const QUERY = gql`
  query AssetsForPlace($placeId: Int) {
    assets(filter: { place_ids: [$placeId] }) {
      id
      name
      enabled
      place {
        id
        name
        resume
        type
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          type
          name
        }
      }
      type {
        id
        name
        entity
        deleted
      }
      deleted
      insertedAt
      updatedAt
    }
  }
`

const AssetsPlaceLoader = ({ children, placeId }) => {
  const { data, loading, error } = useQuery(QUERY, {
    skip: !placeId,
    variables: { placeId },
    client: placesClient,
    fetchPolicy: 'no-cache'
  })

  if (loading) return <Loading />

  return (
    <StatePresenter loading={loading} error={error}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetsPlaceLoader
